// Static catalog for international (non-US) companies. Kept in sync with the
// backend foreign product/state-fee seeders.

export const FOREIGN_COUNTRIES = [
  { code: 'UK', name: 'United Kingdom' },
  { code: 'CA', name: 'Canada' },
  { code: 'SG', name: 'Singapore' },
  { code: 'UAE', name: 'United Arab Emirates' },
];

export const COUNTRY_NAMES = {
  UK: 'United Kingdom',
  CA: 'Canada',
  SG: 'Singapore',
  UAE: 'United Arab Emirates',
  US: 'United States',
};

export const ENTITY_TYPES = {
  UK: [
    'Private Limited Company (Ltd)',
    'Limited Liability Partnership (LLP)',
    'Public Limited Company (Plc)',
  ],
  CA: ['Federal Corporation (Federal Inc.)'],
  SG: [
    'Private Limited Company (Pte. Ltd.)',
    'Sole Proprietorship',
    'Limited Liability Partnership (LLP)',
  ],
  UAE: [
    'Free Zone Limited Liability Company (FZ-LLC)',
    'Mainland Limited Liability Company (LLC)',
    'Sole Establishment / Free Zone Establishment (FZE)',
  ],
};

export const JURISDICTIONS = {
  UK: ['United Kingdom'],
  CA: ['Ontario', 'British Columbia', 'Alberta', 'Quebec', 'Manitoba', 'Saskatchewan', 'Nova Scotia', 'New Brunswick'],
  SG: ['Singapore'],
  UAE: ['Dubai Mainland', 'IFZA', 'Meydan', 'DMCC', 'SHAMS', 'RAKEZ', 'DAFZA', 'Dubai Internet City', 'JAFZA', 'Ajman', 'ADGM'],
};

// Country-specific label for the "Registered Agent" service.
export const REGISTERED_AGENT_LABEL = {
  US: 'Registered Agent',
  UK: 'Registered Office Service',
  CA: 'Registered Office',
  UAE: 'Registered Agent / Local Service Agent',
  SG: 'Corporate Secretary',
};

export function raLabel(country) {
  return REGISTERED_AGENT_LABEL[country] || 'Registered Agent';
}

export const JURISDICTION_LABEL = {
  UK: 'Registry',
  CA: 'Province',
  SG: 'Registry',
  UAE: 'Free Zone / Emirate',
};

// The state_fees key used to resolve a product's government fee.
export function resolveFeeState(product, company) {
  if (!product) return null;
  if (product.fee_source === 'country') return COUNTRY_NAMES[company?.country] || null;
  if (product.fee_source === 'state') return company?.state_of_formation || null;
  return null;
}
